import styled from "styled-components";
import { ListItemTitle } from "../../../shared/ui/list/ListItemTitle";

export const ViewAllListItemTitle = styled(ListItemTitle)`
	justify-content: center;
	align-items: center;
	gap: ${({ theme }) => theme.spacing(1)};
	flex-direction: row;
`;
